import { render } from "./PageCtrl.vue?vue&type=template&id=3f22e006&scoped=true"
import script from "./PageCtrl.vue?vue&type=script&lang=js"
export * from "./PageCtrl.vue?vue&type=script&lang=js"

import "./PageCtrl.vue?vue&type=style&index=0&id=3f22e006&scoped=true&lang=css"

import exportComponent from "D:\\JSD\\03. 사이트\\JSD_SITE\\clientapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f22e006"]])

export default __exports__